module.exports = __webpack_public_path__ + "img/icon-sb-cvv-32x32.9abda1c.svg";